import { Router } from '@reach/router'
import { Slot, StartlibsProvider, useToggle } from '@startlibs/core'
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { customTheme } from '@startlibs/utils';
import React from 'react'
import { CheckScrollOnBottom } from './components/CheckScrollOnBottom'
import { Button, Dialog } from '@startlibs/components'
import { PageLoadingSuspense } from './components/PageLoading'
import { ProviderErrorBoundary } from './pages/errors/ProviderError'
import StartlibsConfig from './UIConfig/StartlibsConfig'
import StyledTheme from './UIConfig/StyledTheme'
import { LoginPage } from './pages/LoginPage';
import { Notifications } from './components/Notifications';
import { MultiFactorAuthPage } from './pages/MultiFactorAuthPage';
import { WorklistPage } from './pages/WorklistPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { ActivityLogsPage } from './pages/ActivityLogsPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { ChangePasswordPage} from './pages/ChangePasswordPage';
import { AuthProvider } from './providers/AuthContext';
import { InstantSharePage } from './pages/InstantSharePage';
import { PasLogin } from './pages/PasLogin';
import { DicomUploaderPage } from './pages/DicomUploaderPage';
import {TaggedUploaderPage} from "./pages/TaggedUploaderPage";
import { VivaReportsSecureSharePage } from './pages/VivaReportsSecureSharePage';
import { WorklistAttachmentsListPage, WorklistAttachmentsPage } from './pages/WorklistAttachmentsListPage';
import { WorklistAttachmentsViewerPage } from './pages/WorklistAttachmentsViewerPage';
import { CustodianViewerPage } from './pages/CustodianViewerPage';

const Identity = React.forwardRef(({ children }, ref) => <React.Fragment>{children}
  <div ref={ref} />
</React.Fragment>)

const DefaultStyle = createGlobalStyle`
  ${customTheme('DefaultStyle')};
`

let isProdEnv = process.env.NODE_ENV !== 'development'
const App = () => {

  const errorDialog = useToggle()
  const tokenExpiredDialog = useToggle()

  return <ThemeProvider theme={StyledTheme}>
    <StartlibsProvider value={StartlibsConfig}>
      <AuthProvider>
        <>
          <DefaultStyle />
          <CheckScrollOnBottom />
          <ProviderErrorBoundary>
            <PageLoadingSuspense>
              <Router component={Identity}>
                <LoginPage
                  path="/login"
                />
                {/* This spa/login is to keep retrocompatibility with previous login only gateway version */}
                <LoginPage
                  path="/spa/login"
                />
                <MultiFactorAuthPage
                  path="/mfa"
                />

                <PasLogin
                  path="/pas-login"
                />
                
                <WorklistPage
                  default
                  path="/"
                />

                <CustodianViewerPage
                  path="/worklist/viewer-loading"
                />

                <WorklistAttachmentsListPage
                  path="/worklist/attachments/list"
                />

                <WorklistAttachmentsViewerPage
                  path="/worklist/attachments/viewer"
                />

                <TaggedUploaderPage
                  path="/taggeduploader"
                />

                <DicomUploaderPage
                  path="/dicomuploader"
                />

                <DicomUploaderPage
                  path="/dicomuploader.php"
                />
                <AnalyticsPage
                  path="/analytics"
                />

                <ChangePasswordPage
                  path="/change-password"
                />

                <ActivityLogsPage
                  path="/activity-logs"
                />

                <UserManagementPage
                  path="/user-management"
                />

                <InstantSharePage
                  path="/instantshare"
                />

                <InstantSharePage
                  path="//instantshare"
                />

                <InstantSharePage
                  path="/instantshare.php"
                />

                <InstantSharePage
                  path="//instantshare.php"
                />

                <VivaReportsSecureSharePage
                  path="/vivareports_secureshared"
                />

                <VivaReportsSecureSharePage
                  path="//vivareports_secureshared"
                />

                <VivaReportsSecureSharePage
                  path="/vivareports_secureshared.php"
                />

                <VivaReportsSecureSharePage
                  path="//vivareports_secureshared.php"
                />
                
              </Router>
              {
                tokenExpiredDialog.isOpen &&
                  <Dialog title="Your session has expired">
                        <p>Please refresh or reopen this page to proceed.</p>
                        <Button highlight onClick={()=>{document.location.reload(true);}}>Refresh</Button>
                  </Dialog>
              }
              {/* {
                errorDialog.isOpen && 
                  <FetchErrorDialog closeDialog={errorDialog.close} item={errorItem} />
              } */}
            </PageLoadingSuspense>
          </ProviderErrorBoundary>
          <Notifications />
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 100 }}>
            <Slot name="Popup" />
          </div>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200 }}>
            <Slot name="Portal" />
            <Slot name="Dialog" />
            <Slot name="Confirm-Dialog" />
            <Slot name="Notification" />
            <Slot name="Notifications" />
          </div>
          <div id="version" style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200}}>
          </div>   
        </>
      </AuthProvider>
    </StartlibsProvider>
  </ThemeProvider>
}

export default App
